// 一覧（シェル）の設定。値は Vite の環境の値（VITE_*）から読む。手元の既定はエミュレータ。
const env = import.meta.env;

const str = (v: unknown, fallback: string) => (typeof v === "string" && v.length > 0 ? v : fallback);

/** 申し込みのボタンを隠したまま本番で確かめるための印：住所に ?billing-preview を付けて開くと、そのタブの間だけボタンを出す */
function billingPreview(): boolean {
  try {
    if (new URLSearchParams(location.search).has("billing-preview")) sessionStorage.setItem("billing-preview", "1");
    return sessionStorage.getItem("billing-preview") === "1";
  } catch {
    return false;
  }
}

export const config = {
  useEmulators: str(env.VITE_USE_EMULATORS, "true") === "true",
  /** ゲームの束を配る別の住所。ここからの postMessage だけを受ける */
  playOrigin: str(env.VITE_PLAY_ORIGIN, "http://127.0.0.1:8788"),
  siteOrigin: str(env.VITE_SITE_ORIGIN, "http://localhost:8787"),
  /** オンライン対戦の部屋の住所（WebSocket）。空にすると対戦の口を閉じる */
  roomsOrigin: typeof env.VITE_ROOMS_ORIGIN === "string" ? env.VITE_ROOMS_ORIGIN : str(env.VITE_USE_EMULATORS, "true") === "true" ? "ws://127.0.0.1:8789" : "",
  firebase: {
    apiKey: str(env.VITE_FIREBASE_API_KEY, "demo-key"),
    authDomain: str(env.VITE_FIREBASE_AUTH_DOMAIN, "localhost"),
    projectId: str(env.VITE_FIREBASE_PROJECT_ID, "demo-web-games"),
    appId: str(env.VITE_FIREBASE_APP_ID, ""),
  },
  functionsRegion: "asia-northeast1",
  ga4Id: str(env.VITE_GA4_ID, ""),
  adsenseClient: str(env.VITE_ADSENSE_CLIENT, ""),
  /** 帯の広告の番号（AdSense の画面で作る data-ad-slot）。空なら帯は出さない */
  adsenseBannerSlot: str(env.VITE_ADSENSE_BANNER_SLOT, ""),
  /** ゲームの全画面・ごほうびの広告（H5 Games Ads の adBreak）。追加の申し込みが承認されてから true にする（docs/ADSENSE.md） */
  adsenseH5: str(env.VITE_ADSENSE_H5, "false") === "true",
  /** 見本の広告（広告の枠の流れを確かめる物）。手元とテストだけで出し、本番では出さない */
  adsSample: str(env.VITE_ADS_SAMPLE, str(env.VITE_USE_EMULATORS, "true")) === "true",
  adsChildDirected: str(env.VITE_ADS_CHILD_DIRECTED, "true") === "true",
  appCheckSiteKey: str(env.VITE_APPCHECK_SITE_KEY, ""),
  /**
   * 広告を消すサブスク（Stripe）。手元はエミュレータと偽の Stripe で動かす。本番は鍵を置いてから true にする（docs/BILLING.md）。
   * 値段は Stripe の価格と必ず合わせる（10/12 是洞さんの答え hq-1012-185548-53e1：全部のゲーム・月額 500円）
   */
  billingEnabled: str(env.VITE_BILLING_ENABLED, str(env.VITE_USE_EMULATORS, "true")) === "true" || billingPreview(),
  billingPriceYen: Number(str(env.VITE_BILLING_PRICE_YEN, "500")),
  /** 特定商取引法に基づく表示のページ。空のうちは、本番で申し込みを出さない */
  legalUrl: str(env.VITE_LEGAL_URL, ""),
  /** 全画面の広告の最短の間隔（10/11 是洞さん「出せるところにはゴリゴリ出していきたい」で 90秒から縮めた） */
  interstitialMinIntervalMs: 60_000,
} as const;
